<template>
    <el-container>
        <el-aside class="app_aside">
            <div class="app_logo">
                <img src="../assets/logo.png" alt="">
            </div>
            <MyAside></MyAside>
        </el-aside>
        <el-container>
            <el-header>
                <MyHeader></MyHeader>
            </el-header>
            <div class="app_con">
                <div class="app_Rig app_RigW">
                    <div class="app_TNav">
                        <div class="app_TList">
                            <div class="app_TItem">首页 </div>
                            <div class="app_TItem ">订单列表 <i class="el-icon-close"></i></div>
                            <div class="app_TItem app_TAct">发布任务 <i class="el-icon-close"></i></div>
                            <div class="app_TItem ">撤单管理 <i class="el-icon-close"></i></div>
                        </div>
                    </div>
                    <el-main>
                        <div class="taskTop">
                            <div class="taskFrom">
                                <el-form ref="detailsFrom" :model="detailsFrom" label-width="60px">
                                    <el-form-item label="搜索:" class="payItem">
                                        <el-input v-model="detailsFrom.name" placeholder="请输入你要搜索的内容"></el-input>
                                    </el-form-item>
                                    <div class="taskFBon">
                                        <el-button icon="el-icon-refresh">重置</el-button> <el-button
                                            icon="el-icon-search">搜索</el-button>
                                    </div>
                                </el-form>
                            </div>
                        </div>
                        <div class="taskCon">
                            <div class="userRTop">
                                <el-tabs v-model="activeName" @tab-click="handleClick">
                                <el-tab-pane label="消息" name="message">
                                    <div class="taskCTable">
                                        <el-table :data="messageData" border>
                                            <el-table-column property="Tit" label="标题" width="350"></el-table-column>
                                            <el-table-column property="content" label="内容"></el-table-column>
                                            <el-table-column property="time" label="时间" width="200"></el-table-column>
                                            <el-table-column label="操作" width="150">
                                                <el-button class="app_mlTableCk" type="text" size="small"
                                                    @click="heipShow = true">查看</el-button>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="通知" name="notice">
                                    <div class="taskCTable">
                                        <el-table :data="noticeData" border>
                                            <el-table-column property="Tit" label="标题" width="350"></el-table-column>
                                            <el-table-column property="content" label="内容"></el-table-column>
                                            <el-table-column property="time" label="时间" width="200"></el-table-column>
                                            <el-table-column label="操作" width="150">
                                                <el-button class="app_mlTableCk" type="text" size="small"
                                                    @click="heipShow = true">查看</el-button>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                            </div>
                        </div>
                        <el-dialog title="1.1.账户注册" class="helpTan" :visible.sync="heipShow">
                            <div class="helpTkBox">
                                <p><span>1.打开浏览器，访问www.1jianji.com，点击“注册”弹出注册表单。填写手机号获取短信验证码，邀请码填写推荐人的邀请码，没有邀请人填写易剪辑邀请码“1TVDOF”，同意并勾选平台服务协议，点击“下一步”，如图：</span>
                                </p>
                                <p><img src="../assets/help_img1.png" alt=""></p>
                                <p><span>1.打开浏览器，访问www.1jianji.com，点击“注册”弹出注册表单。填写手机号获取短信验证码，邀请码填写推荐人的邀请码，没有邀请人填写易剪辑邀请码“1TVDOF”，同意并勾选平台服务协议，点击“下一步”，如图：</span>
                                </p>
                                <p><img src="../assets/help_img1.png" alt=""></p>
                            </div>
                        </el-dialog>
                    </el-main>
                </div>
            </div>

        </el-container>
    </el-container>
</template>

<script>
export default {
    // 指定 name 选项的另好处是便于调试。有名字的组件有更友好的警告信息.
    // 另外，当在有 vue-devtools，未命名组件将显示成 <AnonymousComponent>，这很没有语义。通过提供 name 选项，可以获得更有语义信息的组件树。
    name: 'message',
    data() {
        return {
            activeName:'message',
            detailsFrom: {},
            messageData: [{
                Tit: '1.1.账户注册',
                content: '访问www.1jianji.com，点击“注册”弹出注册表单。填写手机号获取短信验证码，邀请码填写推荐人的邀请码，没有邀请人填写易剪辑邀请码“1TVDOF”，同意并勾选平台服务协议，点击“下一步”',
                time: '2024-06-03'
            }, {
                Tit: '1.1.账户注册',
                content: '访问www.1jianji.com，点击“注册”弹出注册表单。填写手机号获取短信验证码，邀请码填写推荐人的邀请码，没有邀请人填写易剪辑邀请码“1TVDOF”，同意并勾选平台服务协议，点击“下一步”',
                time: '2024-06-03'
            }, {
                Tit: '1.1.账户注册',
                content: '访问www.1jianji.com，点击“注册”弹出注册表单。填写手机号获取短信验证码，邀请码填写推荐人的邀请码，没有邀请人填写易剪辑邀请码“1TVDOF”，同意并勾选平台服务协议，点击“下一步”',
                time: '2024-06-03'
            }, {
                Tit: '1.1.账户注册',
                content: '访问www.1jianji.com，点击“注册”弹出注册表单。填写手机号获取短信验证码，邀请码填写推荐人的邀请码，没有邀请人填写易剪辑邀请码“1TVDOF”，同意并勾选平台服务协议，点击“下一步”',
                time: '2024-06-03'
            }, {
                Tit: '1.1.账户注册',
                content: '访问www.1jianji.com，点击“注册”弹出注册表单。填写手机号获取短信验证码，邀请码填写推荐人的邀请码，没有邀请人填写易剪辑邀请码“1TVDOF”，同意并勾选平台服务协议，点击“下一步”',
                time: '2024-06-03'
            }],
            heipShow: false,
            noticeData: [{
                Tit: '账户注册通知',
                content: '访问www.1jianji.com，点击“注册”弹出注册表单。填写手机号获取短信验证码，邀请码填写推荐人的邀请码，没有邀请人填写易剪辑邀请码“1TVDOF”，同意并勾选平台服务协议，点击“下一步”',
                time: '2024-06-03'
            }, {
                Tit: '账户注册',
                content: '访问www.1jianji.com，点击“注册”弹出注册表单。填写手机号获取短信验证码，邀请码填写推荐人的邀请码，没有邀请人填写易剪辑邀请码“1TVDOF”，同意并勾选平台服务协议，点击“下一步”',
                time: '2024-06-03'
            }, {
                Tit: '账户注册',
                content: '访问www.1jianji.com，点击“注册”弹出注册表单。填写手机号获取短信验证码，邀请码填写推荐人的邀请码，没有邀请人填写易剪辑邀请码“1TVDOF”，同意并勾选平台服务协议，点击“下一步”',
                time: '2024-06-03'
            }, {
                Tit: '账户注册',
                content: '访问www.1jianji.com，点击“注册”弹出注册表单。填写手机号获取短信验证码，邀请码填写推荐人的邀请码，没有邀请人填写易剪辑邀请码“1TVDOF”，同意并勾选平台服务协议，点击“下一步”',
                time: '2024-06-03'
            }, {
                Tit: '账户注册通知',
                content: '访问www.1jianji.com，点击“注册”弹出注册表单。填写手机号获取短信验证码，邀请码填写推荐人的邀请码，没有邀请人填写易剪辑邀请码“1TVDOF”，同意并勾选平台服务协议，点击“下一步”',
                time: '2024-06-03'
            }]
        }

    },
    // 这里为了测试被切换的组件去哪了
    mounted() {

    },
    methods: {

    },
}
</script>

<style></style>